"use client";

import { useNavigate } from "react-router-dom";
import ReportsCalendar from "../../components/ReportsCalendar";

export default function CashUpPage() {
  const navigate = useNavigate();

  const rows = [
    {
      id: 1,
      date: "Friday, 7 Aug 2025",
      by: "Dave Smith",
      notes: "Note goes here....",
    },
    {
      id: 2,
      date: "Thu, 7 Aug 2025",
      by: "Dave Smith",
      notes: "Note goes here....",
    },
    {
      id: 3,
      date: "Thu, 7 Aug 2025",
      by: "Dave Smith",
      notes: "Note goes here....",
    },
    {
      id: 4,
      date: "Thu, 7 Aug 2025",
      by: "Dave Smith",
      notes: "Note goes here....",
    },
    {
      id: 5,
      date: "Thu, 7 Aug 2025",
      by: "Dave Smith",
      notes: "Note goes here....",
    },
    {
      id: 6,
      date: "Thu, 7 Aug 2025",
      by: "Dave Smith",
      notes: "Note goes here....",
    },
    {
      id: 7,
      date: "Thu, 7 Aug 2025",
      by: "Dave Smith",
      notes: "Note goes here....",
    },
    {
      id: 8,
      date: "Thu, 7 Aug 2025",
      by: "Dave Smith",
      notes: "Note goes here....",
    },
    {
      id: 9,
      date: "Wed, 6 Aug 2025",
      by: "Dave Smith",
      notes: "Note goes here....",
    },
    {
      id: 10,
      date: "Tues, 5 Aug 2025",
      by: "Dave Smith",
      notes: "Note goes here....",
    },
    {
      id: 11,
      date: "Mon, 4 Aug 2025",
      by: "Dave Smith",
      notes: "Note goes here....",
    },
    {
      id: 12,
      date: "Sun, 3 Aug 2025",
      by: "Dave Smith",
      notes: "Note goes here....",
    },
    {
      id: 13,
      date: "Sat, 1 Aug 2025",
      by: "Dave Smith",
      notes: "Note goes here....",
    },
    {
      id: 14,
      date: "Tues, 5 Aug 2025",
      by: "Dave Smith",
      notes: "Note goes here....",
    },
  ];

  return (
    <div className="w-full px-4 lg:px-0 py-4 lg:py-0">
      {/* Header */}
      <div className="bg-white border border-gray-200 rounded-xl shadow-sm mb-6">
        <div className="flex flex-col lg:flex-row lg:items-center justify-between p-5 lg:px-6 lg:py-4 gap-4">
          <h1 className="text-xl lg:text-2xl font-bold text-[#885ABB]">Cash Up</h1>

          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 lg:gap-3">
            <div className="grid grid-cols-2 sm:flex sm:flex-row gap-2 lg:gap-3">
              <button
                disabled
                className="px-4 lg:px-6 py-2.5 lg:py-3 border border-gray-300 rounded-lg text-xs lg:text-sm font-medium text-gray-400 bg-gray-50 cursor-not-allowed shadow-sm"
              >
                Print
              </button>

              <button
                disabled
                className="px-4 lg:px-6 py-2.5 lg:py-3 border border-gray-300 rounded-lg text-xs lg:text-sm font-medium text-gray-400 bg-gray-50 cursor-not-allowed shadow-sm"
              >
                Transaction
              </button>
            </div>

            <button className="px-4 lg:px-6 py-2.5 lg:py-3 border border-[#bb9ae1] rounded-lg text-xs lg:text-sm font-bold text-[#402B69] hover:bg-purple-50 transition-colors shadow-sm">
              Open Cash Drawer
            </button>

            {/* ✅ New ReportsCalendar (handles its own popover) */}
            <div className="w-full sm:w-auto">
              <ReportsCalendar />
            </div>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="bg-transparent lg:bg-white lg:border border-gray-200 rounded-xl overflow-hidden">
        {/* Header */}
        <div className="hidden lg:grid grid-cols-[300px_200px_1fr] bg-[#885ABB] text-white font-bold text-[14px] uppercase tracking-wider">
          <div className="px-6 py-4 font-bold border-r border-white/10">Date</div>
          <div className="px-6 py-4 font-bold border-r border-white/10">Completed By</div>
          <div className="px-6 py-4 font-bold">Notes</div>
        </div>

        {/* Rows */}
        <div className="flex flex-col gap-3 lg:gap-0">
          {rows.map((row) => (
            <div
              key={row.id}
              onClick={() => navigate(`/cashup/${row.id}`)}
              className="flex flex-col lg:grid lg:grid-cols-[300px_200px_1fr] bg-white lg:bg-transparent lg:border-t border-gray-100 rounded-xl lg:rounded-none shadow-sm lg:shadow-none border border-gray-100 lg:border-none p-4 lg:p-0 text-sm hover:bg-purple-50/30 transition-all cursor-pointer group"
            >
              {/* Date & Checkbox */}
              <div className="flex items-center gap-4 lg:px-6 lg:py-4 lg:border-r border-gray-50">
                <div className="relative flex items-center h-5 w-5 shrink-0">
                  <input
                    type="checkbox"
                    className="h-5 w-5 appearance-none border-2 border-purple-200 rounded-md cursor-pointer
                      checked:bg-[#885ABB] checked:border-[#885ABB]
                      transition-all focus:ring-2 focus:ring-purple-200 focus:outline-none"
                    onClick={(e) => e.stopPropagation()}
                  />
                  <div className="absolute inset-0 pointer-events-none flex items-center justify-center opacity-0 group-has-[:checked]:opacity-100 transition-opacity">
                    <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="4">
                      <path d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                </div>
                <span className="font-bold lg:font-semibold text-gray-900 lg:text-gray-600 group-hover:text-[#885ABB] transition-colors">{row.date}</span>
              </div>

              {/* By */}
              <div className="lg:px-6 lg:py-4 lg:border-r border-gray-50 mt-3 lg:mt-0 pt-3 lg:pt-0 border-t lg:border-none flex lg:block justify-between items-center">
                <span className="lg:hidden text-[10px] font-bold text-gray-400 uppercase tracking-widest">Completed By</span>
                <span className="text-gray-600 font-medium lg:font-normal">{row.by}</span>
              </div>

              {/* Notes */}
              <div className="lg:px-6 lg:py-4 mt-2 lg:mt-0 flex lg:block justify-between items-center bg-gray-50/50 lg:bg-transparent -mx-4 -mb-4 lg:mx-0 lg:mb-0 p-3 lg:p-4 rounded-b-xl lg:rounded-none">
                <span className="lg:hidden text-[10px] font-bold text-gray-400 uppercase tracking-widest">Notes</span>
                <span className="text-gray-500 font-medium lg:font-normal truncate max-w-[200px] lg:max-w-none">{row.notes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
